<template>
    <div class="box rounded">
        <p class="small" style="margin-top: 10px; color: var(--color-secondary-variant);">Alpha G.O.A.T</p>
        <p class="title small">#1</p>
        <div class="items" :class="{'prevent-select': !selectable}">
            <VoteCard v-for="(choice, i) in choices" :key="i" 
                :captionContent="choice.version" 
                :imgSrc="choice.image"
                :selected="i == selectedIndex"
                :overlay="getCardOverlay(choice)"
                @clicked="handleClick(i)" >
            </VoteCard>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['selected'],
    props: {
      selectable: {type: Boolean, default: false},
      preSelectedIndex: {type: Number, default: -1},
      choices: {
          type: Array,
          default() {
              return [
                {
                  version: 'A',
                  image: require('@/assets/imgs/goat-nft-1.jpg'),
                },
                {
                  version: 'B',
                  image: require('@/assets/imgs/goat-nft-2.jpg')                  
                }
              ];
          }
      },
    },
    methods: {
      handleClick(index) {
          if (!this.selectable) {
              return;
          }
              
          this.selectedIndex = index;
          this.$emit('selected', index);
      },

      getCardOverlay(choice) {
        if(!choice.overlay) {
            return null;
        }

        if(choice.overlay.winner) {
            return { text: 'Winner', image: 'data:image/svg+xml;base64,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' };
        }

        if(choice.overlay.loser) {
            return { text: 'Loser', image: '' };
        }

        return { title: 'Votes', text: choice.overlay.votes };
      }
    },  
    data() {
      return {
          selectedIndex: this.preSelectedIndex,
      };
    }
};
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    flex-direction: column;
    padding: 5px;
    background-color: var(--color-secondary-dark);

    .items {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        gap: 2px;        
    }
}

.prevent-select {
    pointer-events: none;
}
</style>